import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import StoreButton from '../Forms/Store/StoreButton.js';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    margin: '5rem 0'
  },
  card: {
    textAlign: 'center',
    width: '100%',
    maxWidth: 460,
    backgroundColor: '#fff',
    border: `1px solid ${theme.palette.styleguide.beigeDark}`,
    borderRadius: '.7rem',
    padding: '4rem 3rem',
    [theme.breakpoints.down('sm')]: {
      padding: '3rem 2rem'
    }
  },
  logo: {
    width: 56,
    height: 56,
    marginBottom: '1.5rem'
  },
  message: {
    marginBottom: ({ hasAction }) => hasAction ? '2rem' : 0
  }
}));

// Shared graceful fallback for deep links whose id doesn't resolve (unknown/stale
// product, subscription, article, author or hand). Pass translation KEYS, not text.
// Omit actionLabel/onAction for an in-context message with no button.
const NotFoundMessage = ({ message, actionLabel, onAction }) => {
  const { t } = useTranslation();
  const classes = useStyles({ hasAction: !!actionLabel });

  return (
    <div className={classes.wrapper}>
      <div className={classes.card}>
        <img
          className={classes.logo}
          src='/img/components/header/logo_hive.svg'
          alt='BridgeBee'
        />
        <Typography variant='h2' className={classes.message}>
          {t(message)}
        </Typography>
        {actionLabel && (
          <StoreButton label={actionLabel} onClick={onAction} />
        )}
      </div>
    </div>
  );
};

NotFoundMessage.propTypes = {
  message: PropTypes.string.isRequired,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func
};

export default NotFoundMessage;
